import styles from "./Button2.module.css";
import { Link } from "react-router-dom";

// Define the props that the Input component will accept
interface InputProps {
    href?: string;
    name: string;
    text: string;
    type?: string;
    onClick?: () => void;
}

const Button2: React.FC<InputProps> = ({ href, name, text, type, onClick }) => {
    return href ? (
        // <Link href={href} id={name} to={href} className={name} type={type}>
        <Link to={href} id={name} className={name} type={type}>
            <button id={name} className={styles.ctaButton} onClick={onClick} >
                {text}
            </button>
        </Link>
        // </Link>
    ) : (
        <button id={name} className={styles.ctaButton} onClick={onClick}>
            {text}
        </button>
    );
};

export default Button2;